import React from 'react';

function TutoringProfile() {
  return <div>TutoringProfile</div>;
}

export default TutoringProfile;
